import React, { useState, useEffect } from "react";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import TextInput from "../../../UIComponents/TextInput";
// import Loader from "semantic-ui-react/dist/es/elements/Loader";
import Dropdown from "../../../UIComponents/Dropdown";
// import { toast } from "react-toastify";
import moment from "moment";
import { timezones, timezoneObj } from "../../../../lib/timezones";
import "./CompanyDetailsForm.scss";
import { useDispatch, useSelector } from "react-redux";
import { getIndustries } from "../../../../actions/globalAction";
import GoalsDropdown from "../../../UIComponents/MultipleSelect/GoalsDropdown";

const CompanyDetailsForms = ({ company, industries, setIndustries, values, setValues, varySteps }) => {
    // console.log("hereee", props);
    // console.log("resttt", location, history);
    // const [industries, setIndustries] = useState([]);
    const user = useSelector((state) => state.globalReducer.user);
    const goals = [
        {
            label: "Listening",
            value: "Listening",
            desc: "Track the online conversations happening around your brand in real time and derive meaningful insights.",
        },
        {
            label: "Publishing",
            value: "Publishing",
            desc: "Create ,Schedule and Publish content across multiple channels , and analyze the metrics for already Published Post.",
        },
        {
            label: "Response",
            value: "Response",
            desc: "Track your consumer queries in real time and respond to them across various channels.Keep a track on what your agents performance is.",
        },

        {
            label: "Page Analytics",
            value: "Page Analytics",
            desc: "Analyze data from your own social media pages , with the help of real time insights.",
        },
    ];

    const companySize = [
        {
            label: "2-10",
            value: "2-10",
        },
        {
            label: "11-50",
            value: "11-50",
        },
        {
            label: "51-100",
            value: "51-100",
        },
        {
            label: "101-500",
            value: "101-500",
        },

        {
            label: "above 500",
            value: "above 500",
        },
    ];

    const fetchTimezone = () => {
        const initialTimezone = moment.tz.guess(true);

        let countryArr = timezones.filter((timezoneObj) => timezoneObj.utc.includes(initialTimezone));
        return { label: countryArr[0].text.split(" ")[0] + " " + initialTimezone, value: countryArr[0].offset };
    };
    const dispatch = useDispatch();

    useEffect(() => {
        let industryArr = [];

        dispatch(getIndustries()).then((response) => {
            response?.map((object) => {
                if (object.name !== "Other(Business Type Not Listed)") {
                    industryArr.push({ label: object.name, value: object.name });
                }
            });
            industryArr.push({ label: "Other(Business Type Not Listed)", value: "Other(Business Type Not Listed)" });
            setIndustries(industryArr);
        });
        fillFormDetails();
        // setValues({ ...values, timezone: fetchTimezone() });
    }, []);

    const fillFormDetails = () => {
        const data = JSON.parse(localStorage.getItem("company-datails-setup"));
        let selectedGoals = [];
        let goalsVal = company?.goals?.split(", ");
        goalsVal &&
            goals.forEach((ele) => {
                if (goalsVal.includes(ele.value)) {
                    selectedGoals.push(ele);
                }
            });
        setValues({
            ...values,
            user_full_name: data?.user_full_name || company.user_name || "",
            industry: data?.industry || company?.industry || "",
            company_name: data?.company_name || company?.name || "",
            job_title: data?.job_title || user?.job_title || "",
            contact_no: data?.contact_no || user?.contact_no || "",
            country: data?.country || user.country || "",
            timezone: data?.timezone || user.timezone || null,
            timezone_name: data?.timezone_name || user.timezone_name || "",
            goals: data?.goals || selectedGoals,
            // company_size: data?.company_size || null,
        });
    };
    const onChange = (e) => {
        setValues({ ...values, [e.target.id]: e.target.value });
    };

    const handlePhoneChange = (value, country) => {
        let countryValue = timezoneObj[country.countryCode.toUpperCase()];

        setValues({ ...values, contact_no: value, country: countryValue.country, timezone: countryValue.offset, timezone_name: countryValue.name });
    };

    const handleIndustryChange = (value) => {
        setValues({ ...values, industry: value.value });
    };
    const handlecompanySizeChange = (value) => {
        setValues({ ...values, company_size: value.value });
    };
    const handleGoalsChange = (val) => {
        // console.log("vaa", val);
        setValues({ ...values, goals: val });
    };

    const handleEnter = (event) => {
        if (event.key.toLowerCase() === "enter") {
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    };

    return (
        <>
            <div className="company-details-form ">
                <h3>{`We need a few more details to help you with the free trial`}</h3>
                <form>
                    <label className="label" htmlFor="user_full_name">
                        Tell us your name*
                    </label>
                    <TextInput
                        className={`customInputClass`}
                        classNamePrefix="mui-input"
                        value={values.user_full_name}
                        onKeyDown={handleEnter}
                        id="user_full_name"
                        placeholder="Enter your name"
                        onChange={onChange}
                    />
                    <label className="label" htmlFor="company_name">
                        What is the name of your company?*
                    </label>
                    <TextInput
                        value={values.company_name}
                        onKeyDown={handleEnter}
                        id="company_name"
                        placeholder="Enter your Company name"
                        onChange={onChange}
                    />
                    <label className="label" htmlFor="industry">
                        Which industry do you work in?*
                    </label>
                    <Dropdown
                        name="industry"
                        id="industry"
                        value={values.industry ? { label: values.industry, value: values.industry } : null}
                        classNamePrefix="react-select"
                        className={`react-select `}
                        onKeyDown={handleEnter}
                        placeholder="Select Industry"
                        onChange={handleIndustryChange}
                        menuPlacement="top"
                        options={industries}
                    />
                    <label className="label" htmlFor="job_title">
                        How would you describe your role in the organization?*
                    </label>

                    <TextInput value={values.job_title} onKeyDown={handleEnter} id="job_title" placeholder="Enter your role" onChange={onChange} />

                    <label className="label" htmlFor="goals">
                        Which modules are you interested in using?*
                    </label>
                    <GoalsDropdown
                        name="goals"
                        id="goals"
                        placeholder="Select modules"
                        options={goals}
                        classNamePrefix="react-select"
                        className={`react-select `}
                        onKeyDown={handleEnter}
                        onChange={handleGoalsChange}
                        value={values.goals}
                        menuPlacement="top"
                    />

                    {/* <label className="label" htmlFor="company_size">
                        What is the size of your company ?
                    </label>
                    <Dropdown
                        name="company_size"
                        id="company_size"
                        value={values.company_size ? { label: values.company_size, value: values.company_size } : null}
                        classNamePrefix="react-select"
                        className={`react-select `}
                        onKeyDown={handleEnter}
                        placeholder="Select size of the company"
                        onChange={handlecompanySizeChange}
                        menuPlacement="top"
                        options={companySize}
                    /> */}

                    <label className="label" htmlFor="contact_no">
                        What is your contact number?*
                    </label>
                    <ReactPhoneInput
                        placeholder="98XXX-XXXXX"
                        id="contact_no"
                        value={values.contact_no}
                        country={"sg"}
                        onKeyDown={handleEnter}
                        onChange={handlePhoneChange}
                        inputStyle={{ width: "100%", outline: "none", height: "100%", fontSize: "12px", paddingLeft: "55px" }}
                        dropdownStyle={{ fontSize: "12px" }}
                    />
                </form>
                {/* </div> */}
            </div>
        </>
    );
};

export default CompanyDetailsForms;
